module.exports = __webpack_public_path__ + "img/1587515.9dad2d12.svg";